import React from "react";
import { Link } from "react-router-dom";

import icon1 from "../../images/icon/m_01.svg";
import icon2 from "../../images/icon/m_02.svg";
import icon3 from "../../images/icon/m_03.svg";
import icon4 from "../../images/icon/m_04.svg";

const ArrowSVG = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5.22852" y="17.3296" width="17.888" height="2.27149" transform="rotate(-40.2798 5.22852 17.3296)" fill="white" />
    <rect x="7.75781" y="6.25635" width="2.27149" height="2.27149" transform="rotate(-40.2798 7.75781 6.25635)" fill="white" />
    <rect x="10.959" y="6.52002" width="2.27149" height="2.27149" transform="rotate(-40.2798 10.959 6.52002)" fill="white" />
    <rect x="14.1562" y="6.78516" width="2.27149" height="2.27149" transform="rotate(-40.2798 14.1562 6.78516)" fill="white" />
    <rect x="17.0957" y="10.25" width="2.27149" height="2.27149" transform="rotate(-40.2798 17.0957 10.25)" fill="white" />
    <rect x="16.832" y="13.4517" width="2.27149" height="2.27149" transform="rotate(-40.2798 16.832 13.4517)" fill="white" />
    <rect x="16.5684" y="16.6538" width="2.27149" height="2.27149" transform="rotate(-40.2798 16.5684 16.6538)" fill="white" />
  </svg>
);

const products = [
  { icon: icon1, title: "Face Engine", desc: "Identity checking & eKYC with biometric face match and liveness.", link: "/service-details", badge: "Popular" },
  { icon: icon2, title: "Watchlist Screening", desc: "PEP, sanctions screening & negative information checks.", link: "/service-details" },
  { icon: icon3, title: "Bank Statement Analyzer", desc: "Real-time detection of fake & manipulated bank statements.", link: "/service-details" },
  { icon: icon4, title: "Legal Opinion", desc: "Instant AI-powered legal insights for compliance teams.", link: "/service-details" },
  { icon: icon2, title: "Credit Approval Engine", desc: "Provide credit approval decisions anywhere, anytime.", link: "/service-details" },
  { icon: icon3, title: "Custom Integration", desc: "Tailored verification workflows built with our engineers for your specific use case.", link: "/contact" },
];

const MegaMenu1: React.FC = () => {
  return (
    <ul className="submenu">
      <li>
        <div className="mega_menu_wrapper">
          <div className="container-fluid p-0">
            <div className="mega_menu_wrapper_inner">
              <div className="row mt-none-30">
                {/* ---------- LEFT SIDE ---------- */}
                <div className="col-xl-8 col-lg-12 mt-30">
                  <div className="megamenu_pages_wrapper">
                    {/* Row 1: first 3 products */}
                    <div className="row g-10 align-items-stretch">
                      {products.slice(0, 3).map((item, i) => (
                        <div className="col-xl-4 col-lg-4 d-flex" key={i}>
                          <Link className="iconbox_block_2 h-100 w-100" to={item.link} style={{ display: "flex", flexDirection: "column" }}>
                            <span className="icon_title_wrap">
                              <small className="iconbox_icon">
                                <img src={item.icon} alt={item.title} />
                              </small>
                              <small className="iconbox_title">{item.title}</small>
                              {item.badge && <span className="badge">{item.badge}</span>}
                            </span>
                            <span className="description mb-0">{item.desc}</span>
                          </Link>
                        </div>
                      ))}
                    </div>
                    {/* Row 2: last 3 products */}
                    <div className="row g-10 mt-0 align-items-stretch">
                      {products.slice(3).map((item, i) => (
                        <div className="col-xl-4 col-lg-4 d-flex" key={i}>
                          <Link className="iconbox_block_2 h-100 w-100" to={item.link} style={{ display: "flex", flexDirection: "column" }}>
                            <span className="icon_title_wrap">
                              <small className="iconbox_icon">
                                <img src={item.icon} alt={item.title} />
                              </small>
                              <small className="iconbox_title">{item.title}</small>
                              {item.badge && <span className="badge">{item.badge}</span>}
                            </span>
                            <span className="description mb-0">{item.desc}</span>
                          </Link>
                        </div>
                      ))}
                    </div>

                    {/* BUTTONS & REVIEWS */}
                    <ul className="btns_group mt-80 p-0 ul_li_between">
                      <li>
                        <Link className="thm-btn agency-btn megamenu-btn" to="/contact">
                          <span className="text">Get API Key</span>
                          <span className="arrow">
                            <span className="arrow-icon">
                              <ArrowSVG />
                              <ArrowSVG />
                            </span>
                          </span>
                        </Link>
                      </li>
                      <li>
                        <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0" }}>
                          <div style={{
                            width: 40, height: 40, borderRadius: 10, flexShrink: 0,
                            background: "rgba(0,200,150,0.12)", border: "1.5px solid rgba(0,200,150,0.3)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                          }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M10 2L4 5v5c0 4.4 2.6 8.1 6 9 3.4-.9 6-4.6 6-9V5L10 2z" fill="rgba(0,200,150,0.15)" stroke="#00c896" strokeWidth="1.5"/>
                              <path d="M7 10l2 2 4-4" stroke="#00c896" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 800, color: "#0f2040" }}>OJK Licensed</div>
                            <div style={{ fontSize: 11, color: "rgba(15,32,64,0.5)" }}>Otoritas Jasa Keuangan certified</div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0" }}>
                          <div style={{
                            width: 40, height: 40, borderRadius: 10, flexShrink: 0,
                            background: "rgba(0,200,150,0.12)", border: "1.5px solid rgba(0,200,150,0.3)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                          }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <rect x="3" y="3" width="14" height="14" rx="3" stroke="#00c896" strokeWidth="1.5" fill="rgba(0,200,150,0.12)"/>
                              <path d="M7 10l2 2 4-4" stroke="#00c896" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 800, color: "#0f2040" }}>ISO 27001</div>
                            <div style={{ fontSize: 11, color: "rgba(15,32,64,0.5)" }}>Information security certified</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* ---------- RIGHT SIDE ---------- */}
                <div className="col-xl-4 col-lg-12 mt-30">
                  <div className="mega_menu_left">
                    <div className="author_box">
                      <div className="author_image">
                        <svg width="171" height="186" viewBox="0 0 171 186" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ borderRadius: 12 }}>
                          <rect width="171" height="186" fill="#0f2040"/>
                          <rect x="12" y="16" width="147" height="154" rx="8" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
                          <rect x="20" y="24" width="96" height="14" rx="4" fill="rgba(0,200,150,0.15)"/>
                          <text x="26" y="34" fontSize="8" fontWeight="700" fill="#00c896" fontFamily="monospace">POST /v1/ekyc/verify</text>
                          {[
                            { y: 50, w: 120, color: "rgba(255,255,255,0.12)" },
                            { y: 66, w: 90,  color: "rgba(255,255,255,0.08)" },
                            { y: 82, w: 110, color: "rgba(255,255,255,0.08)" },
                            { y: 98, w: 80,  color: "rgba(255,255,255,0.08)" },
                          ].map((l,i) => <rect key={i} x="20" y={l.y} width={l.w} height="8" rx="3" fill={l.color}/>)}
                          <circle cx="85" cy="140" r="22" fill="rgba(0,200,150,0.12)" stroke="#00c896" strokeWidth="1.5"/>
                          <path d="M78 138 L83 143 L92 134" stroke="#00c896" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <text x="85" y="172" fontSize="8" fill="rgba(255,255,255,0.4)" textAnchor="middle" fontFamily="system-ui">Verified</text>
                        </svg>
                      </div>
                      <div className="author_box_content">
                        <h3 className="mb-60 text-white">
                          Ready to verify identities at scale?
                        </h3>
                        <Link className="thm-btn agency-btn megamenu-btn" to="/contact">
                          <span className="text">Start free trial</span>
                          <span className="arrow">
                            <span className="arrow-icon">
                              <ArrowSVG />
                              <ArrowSVG />
                            </span>
                          </span>
                        </Link>
                      </div>
                    </div>

                    <div className="author_box">
                      <div className="author_image">
                        <svg width="171" height="186" viewBox="0 0 171 186" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ borderRadius: 12 }}>
                          <rect width="171" height="186" fill="#1a3460"/>
                          <circle cx="85" cy="78" r="38" fill="rgba(0,200,150,0.15)" stroke="#00c896" strokeWidth="1.5"/>
                          <circle cx="85" cy="68" r="18" fill="rgba(0,200,150,0.25)"/>
                          <ellipse cx="85" cy="108" rx="28" ry="20" fill="rgba(0,200,150,0.2)"/>
                          <text x="85" y="74" fontSize="20" fontWeight="800" fill="#00c896" textAnchor="middle" fontFamily="system-ui">R</text>
                          <text x="85" y="138" fontSize="11" fontWeight="700" fill="white" textAnchor="middle" fontFamily="system-ui">Rian Hidayat</text>
                          <text x="85" y="154" fontSize="9" fill="rgba(255,255,255,0.5)" textAnchor="middle" fontFamily="system-ui">CEO, Aggre Capital</text>
                          <rect x="55" y="163" width="60" height="14" rx="7" fill="rgba(0,200,150,0.15)"/>
                          <text x="85" y="173" fontSize="8" fontWeight="700" fill="#00c896" textAnchor="middle" fontFamily="system-ui">✓ Verified Client</text>
                        </svg>
                      </div>
                      <div className="author_box_content">
                        <p className="mb-45 text-white">
                          "TrustEngine cut our onboarding drop-off by 40%.
                          The eKYC API is blazing fast and the face match
                          accuracy is genuinely exceptional."
                        </p>
                        <div className="author_holder">
                          <h4 className="author_name text-white">Rian Hidayat</h4>
                          <span className="author_designation text-white">
                            CEO, <Link to="/">Aggre Capital</Link>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default MegaMenu1;
